import theme, { buildTheme, type Theme } from '@shared/theme';
import { ETCHO_TENANT_ID } from '@shared/data/Tenants';
import type { TenantConfig } from './tenantConfig';

/**
 * The styled-components theme for the resolved tenant. Mirrors the PDF
 * pipeline's rules (pdf-render-options in the backend):
 * - no tenant (unknown hostname / config endpoint down) -> exact default
 *   Etcho theme object
 * - the Etcho tenant itself -> default theme too; its stored branding is a
 *   description of the default look, and feeding it through buildTheme
 *   would remap the colour families
 * - any other tenant -> buildTheme over its branding (primary -> highlight
 *   family, accentContrast -> dark families, accent -> light tints, text
 *   defaults to black unless the tenant overrides colors.text)
 */
export function appThemeFor(config: TenantConfig | null): Theme {
    if (!config || config.tenantId === ETCHO_TENANT_ID) {
        return theme;
    }

    return buildTheme(config.branding);
}
